import { Button } from "@progress/kendo-react-buttons";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";
import React from "react";
import { useState } from "react";
import CompanyAccounting from "./CompanyAccounting";
import CompanyProfile from "./CompanyDetails";
import styles from "../Settings.module.scss";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { updateCompany, useCompany } from "services/companyService";
import SubmitButton from "components/common/SubmitButton";

const Company = () => {
  const [tabs, setTabs] = useState(["Company Details", "Financial Settings"]);
  const [selected, setSelected] = React.useState(0);
  const navigate = useNavigate();
  const [serviceAddress, setServiceAddress] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const { data: subdata } = useCompany();

  const updateAddress = (data) => {
    if (data.workingDays !== undefined && data.workingDays !== null) {
      const selWd = [];
      data?.workingDays?.map((day) => {
        if (day?.isChecked) {
          selWd.push(day?.label);
        }
      });
      data.workingDays = selWd?.toString(",");
    }
    setServiceAddress({ ...serviceAddress, ...data });
    setHasChanges(true);
  };

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const submitHandler = async () => {
    if (!hasChanges) return;

    setIsSubmitting(true);
    try {
      const res = await updateCompany(subdata.id, serviceAddress);
      if (res.success) {
        toast.success("Company Updated Successfully");
      }
      setHasChanges(false);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className={`${styles["company"]} d-flex flex-column h-100 w-100`}>
      <div className="flex-grow-1 overflow-auto">
        <TabStrip
          keepTabsMounted={true}
          selected={selected}
          onSelect={handleSelect}
          className="mt-2 pagetab"
        >
          {tabs.map((item, index) => {
            return (
              <TabStripTab
                key={index}
                title={
                  <PageTabItemTitle
                    title={item}
                    index={tabs.indexOf(item)}
                    selected={selected}
                  />
                }
              >
                <div className={`${styles["company-tabs"]}`}>
                  {item === "Company Details" && (
                    <CompanyProfile updateAddress={updateAddress} />
                  )}
                  {item === "Financial Settings" && (
                    <CompanyAccounting updateAddress={updateAddress} />
                  )}
                </div>
              </TabStripTab>
            );
          })}
        </TabStrip>
      </div>
      <div className={`${styles["buttons-container"]} d-flex align-items-center justify-content-end gap-2 px-4 py-3`}>
        <Button
          className="common-btn bgBtnSecondary"
          type="button"
          onClick={() => navigate(`/settings`)}
        >
          Cancel
        </Button>
        <SubmitButton
          onClick={submitHandler}
          isLoading={isSubmitting}
          disabled={!hasChanges}
        >
          Update
        </SubmitButton>
      </div>
    </div>
  );
};

export default Company;
